import http from '@/support/plugin/axios'

export const 

authenticate = ( loginInfo ) => http.post(`/auth`, loginInfo)